import { authHeader, BASE_URL, handleResponse } from '@helpers/api';

function get(scope) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    };
    const query = scope ? `?scope=${scope}` : '';
    return fetch(`${BASE_URL}api/channels/${query}`, requestOptions).then(handleResponse);
}

function deleteChannel(id) {
    const requestOptions = {
        method: 'DELETE',
        headers: authHeader(),
    };

    return fetch(`${BASE_URL}api/channels/${id}`, requestOptions).then(handleResponse);
}

function createOrUpdateChannelSms(data) {
    const requestOptions = {
        method: 'PUT',
        headers: authHeader(),
        body: JSON.stringify(data),
    };

    return fetch(`${BASE_URL}api/channels/sms`, requestOptions).then(handleResponse);
}

function createOrUpdateChannelWhatsApp(data) {
    const requestOptions = {
        method: 'PUT',
        headers: authHeader(),
        body: JSON.stringify(data),
    };

    return fetch(`${BASE_URL}api/channels/whatsapp`, requestOptions).then(handleResponse);
}

function createOrUpdateChannelLiveChat(data) {
    const requestOptions = {
        method: 'PUT',
        headers: authHeader(),
        body: JSON.stringify(data),
    };

    return fetch(`${BASE_URL}api/channels/live-chat`, requestOptions).then(handleResponse);
}

function rotateLiveChatSigningSecret(id) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
    };

    return fetch(`${BASE_URL}api/channels/${id}/live-chat/signing-secret`, requestOptions).then(handleResponse);
}

function createOrUpdateChannelFacebook(data) {
    const requestOptions = {
        method: 'PUT',
        headers: authHeader(),
        body: JSON.stringify({ ...data, integrationId: data.integrationId || null }),
    };

    return fetch(`${BASE_URL}api/channels/facebook`, requestOptions).then(handleResponse);
}

function createOrUpdateChannelInstagram(data) {
    const requestOptions = {
        method: 'PUT',
        headers: authHeader(),
        body: JSON.stringify({ ...data, integrationId: data.integrationId || null }),
    };

    return fetch(`${BASE_URL}api/channels/instagram`, requestOptions).then(handleResponse);
}

function getFacebookPages() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    };

    return fetch(`${BASE_URL}api/channels/facebook/available-pages`, requestOptions).then(handleResponse);
}

function getInstagramPages() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    };

    return fetch(`${BASE_URL}api/channels/instagram/available-pages`, requestOptions).then(handleResponse);
}

function deleteInstagramChannel(id) {
    const requestOptions = {
        method: 'DELETE',
        headers: authHeader(),
    };

    return fetch(`${BASE_URL}api/channels/instagram/${id}`, requestOptions).then(handleResponse);
}

function createOrUpdateChannelEmail(data) {
    const requestOptions = {
        method: 'PUT',
        headers: authHeader(),
        body: JSON.stringify(data),
    };

    return fetch(`${BASE_URL}api/channels/email`, requestOptions).then(handleResponse);
}

function createOrUpdateChannelWhatsAppBusiness(data) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(data),
    };

    return fetch(`${BASE_URL}api/channels/whatsapp/official`, requestOptions).then(handleResponse);
}

function getWhatsAppBusinessPhoneNumbers() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    };

    return fetch(`${BASE_URL}api/channels/whatsapp/official/phone-numbers`, requestOptions).then(handleResponse);
}

function getWhatsAppBusinessTemplates() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    };

    return fetch(`${BASE_URL}api/channels/whatsapp/official/message-templates`, requestOptions).then(handleResponse);
}

function createHostedEmailChannel(data) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(data),
    };

    return fetch(`${BASE_URL}api/channels/email/hosted`, requestOptions).then(handleResponse);
}

function getEmailDomain(id) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    };

    return fetch(`${BASE_URL}api/email-domains/${id}`, requestOptions).then(handleResponse);
}

function checkEmailDomain(id) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
    };

    return fetch(`${BASE_URL}api/email-domains/${id}:check`, requestOptions).then(handleResponse);
}

export const channelsService = {
    get,
    deleteChannel,
    createOrUpdateChannelSms,
    createOrUpdateChannelWhatsApp,
    createOrUpdateChannelWhatsAppBusiness,
    createOrUpdateChannelLiveChat,
    rotateLiveChatSigningSecret,
    createOrUpdateChannelFacebook,
    createOrUpdateChannelInstagram,
    getFacebookPages,
    getInstagramPages,
    deleteInstagramChannel,
    createOrUpdateChannelEmail,
    createHostedEmailChannel,
    getEmailDomain,
    checkEmailDomain,
    getWhatsAppBusinessPhoneNumbers,
    getWhatsAppBusinessTemplates,
};
